export var DistanceFunction;
(function (DistanceFunction) {
    /**
     * Sensible default distance function, based on `===`
     *
     * @returns `0` if the two values satisfy `===`, `Number.POSITIVE_INFINITY` otherwise
     */
    DistanceFunction.defaultFunction = (one, another) => (one === another ? 0 : Number.POSITIVE_INFINITY);
})(DistanceFunction || (DistanceFunction = {}));
//# sourceMappingURL=distanceFunction.mjs.map